import { useSuspenseQuery } from "@tanstack/react-query"

import { getBillingPeriods } from "../../app/services/billing"

export function useBillingPeriodsQuery() {
  return useSuspenseQuery({
    queryKey: ["billingPeriods"],
    queryFn: getBillingPeriods,
  })
}
